import { ReactNode, useMemo } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { enUS, ruRU } from '@mui/x-date-pickers/locales';

import { LocaleCode } from '@/entities/account';
import { useProfile } from '@/entities/profile';
import { useLocale } from '@/shared/stores/accountStore';

const locales = {
  ru: ruRU.components.MuiLocalizationProvider.defaultProps.localeText,
  en: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
};

interface LocaleProviderProps {
  children: ReactNode;
}

export const PickersLocaleProvider = ({ children }: LocaleProviderProps) => {
  const localeStore = useLocale();
  const { profile } = useProfile();

  const systemLocale = profile?.locale;

  const localeCode = useMemo(() => {
    return (systemLocale as LocaleCode) ?? (localeStore as LocaleCode);
  }, [systemLocale, localeStore]);

  const localeText = useMemo(() => {
    return locales[localeCode] || locales.ru;
  }, [localeCode]);

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      localeText={localeText}
      adapterLocale={localeCode === 'ru' ? 'ru' : 'en-gb'}
    >
      {children}
    </LocalizationProvider>
  );
};
